import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Notifications, { error as errorNotif } from "react-notification-system-redux";
import styled from "styled-components";

import { ERROR_INCORECT_SET_PASSWORD_TOKEN } from "_constants";
import breakpoints from "_constants/breakpoints";
import { userActions } from "_store/actions";
import { history } from "_helpers";
import { config } from "_config";

import imgBanner from "assets/img/HomeBanner_centeredLogo.jpg";

import PasswordValidation from "widget/PasswordValidation";
import Brand from "widget/Brand";
import { validatePassword } from "_helpers";

const Layout = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: url(${imgBanner}) no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 624px;

  @media (max-height: 624px) {
    min-height: 0;
  }
`;
const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Header = styled.div`
  padding: 15px 15px 0;
  display: flex;
  justify-content: center;
`;
const Content = styled.div`
  padding: 15px 15px 10px;
  font-size: 22px;
  line-height: 30px;

  @media (max-width: ${breakpoints.mobileS}) {
    font-size: 12px;
    line-height: 14px;

    .form-control {
      font-size: 12px;
    }
  }
`;
const Group = styled(Form.Group)`
  margin-bottom: 1rem;
`;
const StyledButton = styled(Button)`
  font-size: 1em;
`;
const Buttons = styled.div`
  display: flex;
  justify-content: end;
`;

export default function SetPassword() {
  const dispatch = useDispatch();

  const { notifications } = useSelector((store) => store);

  const [password, setPasword] = useState("");
  const [confirmPassword, setConfirmPasword] = useState("");
  const [searchParams] = useSearchParams();

  // const passwordRegex = new RegExp(/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])(?!.*[ ]).{8,}$/);
  const isPasswordValid = validatePassword(password);
  const isDirtyNewPassword = password !== "";
  const isDirtyConfirmPassword = confirmPassword !== "";

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;

    if (!!confirmPassword && !!password && password === confirmPassword && form.checkValidity() === true) {
      const token = searchParams.get("token");

      dispatch(userActions.signin({ token, password, category: "TRADEMARKS" }));
    }
  };

  useEffect(() => {
    if (!searchParams.get("token")) {
      dispatch(errorNotif({ title: "Error", message: ERROR_INCORECT_SET_PASSWORD_TOKEN, autoDismiss: 0 }));
      history.push(config.publicUrl + "/login");
    }
  }, [searchParams]);

  return (
    <Layout>
      <Container fluid>
        <Row className="justify-content-center mt-5">
          <Col xs={10} md={6} lg={4}>
            <div className="card">
              <Header>
                <Brand />
              </Header>
              <Content>
                <StyledForm onSubmit={handleSubmit}>
                  <Group controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      required
                      type="password"
                      placeholder="Password"
                      name="password"
                      isInvalid={isDirtyNewPassword && !isPasswordValid}
                      value={password}
                      onChange={({ target: { value } }) => setPasword(value)}
                    />
                    <Form.Control.Feedback type="invalid">
                      <PasswordValidation password={password} />
                    </Form.Control.Feedback>
                  </Group>

                  <Group controlId="formBasicConfirmPassword">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                      required
                      type="password"
                      placeholder="Password"
                      name="confirmPassword"
                      isInvalid={isDirtyConfirmPassword && password !== confirmPassword}
                      value={confirmPassword}
                      onChange={({ target: { value } }) => setConfirmPasword(value)}
                    />
                    <Form.Control.Feedback type="invalid">Passwords is not equal!</Form.Control.Feedback>
                  </Group>
                  <Buttons>
                    <StyledButton
                      variant="primary"
                      type="submit"
                      disabled={!isPasswordValid || password !== confirmPassword}
                      title={!isPasswordValid || password !== confirmPassword ? "Please, enter correct values" : ""}
                    >
                      Confirm
                    </StyledButton>
                  </Buttons>
                </StyledForm>
              </Content>
            </div>
          </Col>
        </Row>
      </Container>

      <Notifications notifications={notifications} />
    </Layout>
  );
}
